import { Components, Theme } from "@mui/material";

export default function Link(theme: Theme): Components["MuiLink"] {
  return {
    styleOverrides: {
      root: { display: "inline-block", cursor: "pointer" },
    },
  };
}
